<!-- 抄表数据总览 -->
<template>
  <div class="reading-approval">
    <!-- 顶部筛选区 -->
    <h3 style="font-weight: 700; margin-bottom: 1.5em">周期抄表数据统计</h3>
    <a-form layout="inline" class="filter-form">
      <a-form-item label="抄表员：">
        <a-select
          show-search
          :filter-option="filterReaderOption"
          v-model="readerId"
          placeholder="请输入抄表员名称搜索"
          style="width: 200px"
          @change="readerchange"
          allow-clear
        >
          <a-select-option v-for="item in readerList" :key="item.id" :value="item.id">
            {{ item.readerName }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-button @click="onReset1">重置</a-button>
      </a-form-item>
    </a-form>

    <!-- 统计区块 -->
    <div class="dashboard">
      <div class="dashboard-item">
        <!-- 饼图：抄表状态统计 -->
        <div ref="pieChart" style="width: 100%; height: 260px"></div>
      </div>
      <div class="dashboard-item">
        <!-- 数据看板：进度条 -->
        <div class="progress-board">
          <div class="stats-header">
            <span class="stats-title">数据看板</span>
            <span class="stats-total"
              >总用户数：<span class="primary" style="font-weight: bold; font-size: 20px">{{ stats.total }}</span>
              户</span
            >
          </div>
          <div class="stats-item">
            <div class="stats-info">
              <span class="stats-label">已抄用户数</span>
              <span class="stats-value primary">{{ stats.unread }}</span>
              <span class="stats-unit">户</span>
              <span class="stats-percent">({{ stats.already_read_percentage || '0%' }})</span>
            </div>
            <a-progress
              :percent="parseFloat((stats.already_read_percentage || '0').toString().replace('%', ''))"
              :stroke-color="{
                '0%': '#108ee9',
                '100%': '#87d068',
              }"
              :stroke-width="12"
              status="active"
            />
          </div>
          <div class="stats-item">
            <div class="stats-info">
              <span class="stats-label">未抄用户数</span>
              <span class="stats-value danger">{{ stats.pending }}</span>
              <span class="stats-unit">户</span>
              <span class="stats-percent">({{ stats.not_read_percentage || '0%' }})</span>
            </div>
            <a-progress
              :percent="parseFloat((stats.not_read_percentage || '0').toString().replace('%', ''))"
              :stroke-color="{
                '0%': '#ff4d4f',
                '100%': '#ffa39e',
              }"
              status="active"
              :stroke-width="12"
            />
          </div>
        </div>
      </div>
      <div class="dashboard-item">
        <!-- 柱状图：已抄水量统计 -->
        <div ref="barChart" style="width: 100%; height: 260px"></div>
      </div>
    </div>
    <a-form layout="inline" class="filter-form">
      <a-form-item label="用户：">
        <UserSelect v-model="filters.userCode" @change="onUserSelectChange" :show-debug="true" />
      </a-form-item>
      <a-form-item label="抄表状态：">
        <a-select v-model="filters.status" style="width: 150px" @change="onSearch" allow-clear>
          <a-select-option value="">全部</a-select-option>
          <a-select-option value="0">未抄表</a-select-option>
          <a-select-option value="1">已抄表</a-select-option>
          <!-- <a-select-option value="2">已推送</a-select-option> -->
        </a-select>
      </a-form-item>

      <a-form-item label="用水性质：">
        <a-select v-model="filters.waterUsageType" style="width: 150px">
          <a-select-option :value="1">居民用水</a-select-option>
          <a-select-option :value="2">非居民用水</a-select-option>
          <a-select-option :value="3">特种用水</a-select-option>
          <a-select-option :value="4">工业用水</a-select-option>
          <a-select-option :value="5">混合用水</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item>
        <a-button type="primary" @click="onSearch">查询</a-button>
      </a-form-item>
      <a-form-item>
        <a-button @click="onReset2">重置</a-button>
      </a-form-item>
    </a-form>
    <!-- 数据表格 -->
    <a-table
      :columns="columns"
      :data-source="tableData"
      row-key="userCode"
      :pagination="pagination"
      @change="handleTableChange"
      bordered
      class="reading-table"
      :scroll="{ x: 1600 }"
    >
      <template slot="readingStatus" slot-scope="text">
        <a-tag :color="getStatusColor(text)">
          {{ { 0: '未抄表', 1: '已抄表' }[text] || text }}
        </a-tag>
      </template>
      <template slot="action" slot-scope="record">
        <a v-if="record.readingStatus !== 0 && record.imageUrl" @click="viewImage(record.imageUrl)">查看图片</a>
      </template>
    </a-table>
  </div>
</template>

<script>
import UserSelect from '@/views/meter-reading/components/UserSelect.vue'

export default {
  name: 'ReadingApproval',
  components: {
    UserSelect,
  },
  data() {
    return {
      readerId: '',
      filters: {
        userCode: '',

        status: '',
        userName: '',
        waterUsageType: '',
      },
      readerList: [],
      pieOption: {
        title: {
          text: '抄表状态统计',
          left: 'left',
          top: 3,
          textStyle: {
            fontSize: 16,
          },
        },
        tooltip: { trigger: 'item' },
        legend: { bottom: 0 },
        color: ['#f5222d', '#1890ff', '#52c41a'],
        series: [
          {
            name: '抄表状态',
            type: 'pie',
            radius: '70%',
            data: [],
            label: {
              formatter: '{b}: {d}%',
            },
          },
        ],
      },
      barOption: {
        title: {
          text: '已抄水量统计',
          left: 'left',
          top: 3,
          textStyle: {
            fontSize: 16,
          },
        },
        tooltip: { trigger: 'axis' },
        xAxis: {
          type: 'category',
          data: [],
        },
        yAxis: { type: 'value' },
        series: [
          {
            data: [],
            type: 'bar',
            itemStyle: { color: '#1890ff' },
          },
        ],
      },
      stats: {
        total: 0,
        unread: 0,
        pending: 0,
        already_read_percentage: 0,
        pushedPercent: 0,
      },
      columns: [
        { title: '用户编码', dataIndex: 'userCode', key: 'userCode', width: 120, ellipsis: true },
        { title: '用户名', dataIndex: 'userName', key: 'userName', width: 120, ellipsis: true },
        { title: '水表编号', dataIndex: 'meterNumber', key: 'meterNumber', width: 120, ellipsis: true },
        { title: '用户地址', dataIndex: 'address', key: 'address', width: 200, ellipsis: true },
        {
          title: '用水性质',
          dataIndex: 'waterUsageType',
          key: 'waterUsageType',
          width: 100,
          customRender: (text) => {
            const map = { 1: '居民用水', 2: '非居民用水', 3: '特种用水', 4: '工业用水', 5: '混合用水' }
            return map[text] || text
          },
        },
        { title: '上期行至', dataIndex: 'previousReading', key: 'previousReading', width: 100 },
        { title: '上期用水量(m³)', dataIndex: 'previousUsage', key: 'previousUsage', width: 120 },
        {
          title: '上期抄表时间',
          dataIndex: 'previousReadingTime',
          key: 'previousReadingTime',
          width: 150,
          ellipsis: true,
          customRender: (text) => {
            return {
              children: text,
              props: {
                title: text, // 添加title属性用于tooltip
              },
            }
          },
        },
        { title: '本期行至', dataIndex: 'currentReading', key: 'currentReading', width: 100 },
        { title: '本期用水量(m³)', dataIndex: 'currentUsage', key: 'currentUsage', width: 120 },
        { title: '补充水量', dataIndex: 'supplementaryWaterAmount', key: 'supplementaryWaterAmount', width: 120 },
        {
          title: '抄表员',
          dataIndex: 'readerName',
          key: 'readerName',
          width: 100,
          ellipsis: true,
          customRender: (text) => {
            return {
              children: text,
              props: {
                title: text, // 添加title属性用于tooltip
              },
            }
          },
        },
        {
          title: '抄表时间',
          dataIndex: 'currentReadingTime',
          key: 'currentReadingTime',
          width: 150,
          ellipsis: true,
          customRender: (text) => {
            return {
              children: text,
              props: {
                title: text, // 添加title属性用于tooltip
              },
            }
          },
        },
        {
          title: '抄表状态',
          dataIndex: 'readingStatus',
          key: 'readingStatus',
          width: 100,
          scopedSlots: { customRender: 'readingStatus' },
        },
        {
          title: '图片',
          key: 'action',
          width: 100,
          scopedSlots: { customRender: 'action' },
        },
      ],
      tableData: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: (total) => `共 ${total} 条`,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'],
      },
      pieChartInstance: null,
      barChartInstance: null,
      statsLoading: false,
      waterUsageLoading: false,
      waterUsageParams: {
        startDate: '',
        endDate: '',
        readerId: '',
      },
    }
  },
  created() {
    this.getReaderList()
    this.fetchTableData()
  },
  mounted() {
    this.initCharts()
    this.fetchStats()
    this.fetchWaterUsage()
  },
  beforeDestroy() {
    if (this.pieChartInstance) this.pieChartInstance.dispose()
    if (this.barChartInstance) this.barChartInstance.dispose()
  },
  methods: {
    initCharts() {
      this.pieChartInstance = echarts.init(this.$refs.pieChart)
      this.pieChartInstance.setOption(this.pieOption)
      this.barChartInstance = echarts.init(this.$refs.barChart)
      this.barChartInstance.setOption(this.barOption)
    },
    async fetchStatsBoard() {
      this.statsLoading = true
      try {
        const { data: resp } = await this.$http.get('/meter-manager/meter_reading_task_details/stats/regular', {
          params: { readerId: this.readerId },
        })
        const data = resp || {}
        this.stats = {
          total: Number(data['应抄用户']) || 0,
          unread: Number(data['已抄用户']) || 0,
          pending: Number(data['未抄用户']) || 0,
          already_read_percentage: data.already_read_percentage,
          not_read_percentage: data.not_read_percentage,
        }
      } catch (e) {
        this.$message.error('获取数据看板失败')
      }
      this.statsLoading = false
    },
    async fetchStatsPie() {
      try {
        const { data: pieResp } = await this.$http.get('/meter-manager/meter_reading_task_details/status/regular', {
          params: { readerId: this.readerId },
        })
        const pieData = pieResp || {}
        this.pieOption.series[0].data = [
          { value: Number(pieData.unread_count) || 0, name: '未抄表' },
          { value: Number(pieData.read_count) || 0, name: '已抄表' },
          // { value: Number(pieData.pushed_count) || 0, name: '已推送' }
        ]
        if (this.pieChartInstance) {
          this.pieChartInstance.setOption(this.pieOption)
        }
      } catch (e) {
        this.$message.error('获取抄表状态统计失败')
      }
    },
    async fetchStats() {
      this.fetchStatsBoard()
      this.fetchStatsPie()
    },
    async fetchWaterUsage() {
      this.waterUsageLoading = true
      try {
        // 计算最近7天
        const end = new Date()
        const start = new Date()
        start.setDate(end.getDate() - 6)
        const format = (d) =>
          `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d
            .getDate()
            .toString()
            .padStart(2, '0')}`
        const startDate = format(start)
        const endDate = format(end)
        const { data } = await this.$http.get('/meter-manager/meter_reading_task_details/water-usage', {
          params: {
            startDate,
            endDate,
            readerId: this.readerId,
          },
        })
        // 适配新返回格式
        const xAxis = (data || []).map((item) => item.date)
        const series = (data || []).map((item) => Number(item.totalWaterUsage) || 0)
        this.barOption.xAxis.data = xAxis
        this.barOption.series[0].data = series
        if (this.barChartInstance) {
          this.barChartInstance.setOption(this.barOption)
        }
      } catch (e) {
        this.$message.error('获取水量统计失败')
      }
      this.waterUsageLoading = false
    },
    async fetchTableData() {
      const params = {
        limit: this.pagination.pageSize,
        page: this.pagination.current,
        readingStatus: this.filters.status,
        userCode: this.filters.userCode,
        userName: this.filters.userName,
        waterUsageType: this.filters.waterUsageType,
        readerId: this.readerId,
      }
      try {
        const { data } = await this.$http.get('/meter-manager/meter_reading_task_details/page', { params })
        this.tableData = data.list || []
        this.pagination.total = Number(data.total) || 0
      } catch (e) {
        this.$message.error('获取列表失败')
      }
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.fetchTableData()
    },
    async onSearch() {
      this.pagination.current = 1
      await this.fetchTableData()
    },
    readerchange() {
      this.fetchWaterUsage()
      this.fetchStatsBoard()
      this.fetchStatsPie()
      this.pagination.current = 1
      this.fetchTableData()
    },
    onReset1() {
      this.readerId = ''
      this.fetchStatsBoard()
      this.fetchStatsPie()
      this.fetchWaterUsage()
    },
    onReset2() {
      this.filters = {
        userCode: '',
        status: '',
        userName: '',
        waterUsageType: '',
      }
      this.pagination.current = 1
      this.fetchTableData()
    },
    statusClass(status) {
      if (status === '未抄表') return 'status-unread'
      if (status === '已抄表') return 'status-pending'
      // if (status === '已推送') return 'status-readed'
      return ''
    },
    viewImage(url) {
      window.open(url, '_blank')
    },
    onUserSelectChange(value, user) {
      console.log('用户选择变化:', value, user)
      if (user) {
        this.filters.userName = user.userName
        console.log('设置用户名:', user.userName)
      } else {
        this.filters.userName = ''
        console.log('清空用户名')
      }
      this.onSearch()
    },
    getReaderList(search = '') {
      this.$http
        .get('/meter-manager/meter_readers/list', { params: { name: search } })
        .then(({ data }) => {
          this.readerList = data || []
        })
        .catch(() => {})
    },
    filterReaderOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    getStatusColor(status) {
      const colorMap = {
        0: '#f5222d', // 未抄表 - 红色
        1: '#1890ff', // 已抄表 - 蓝色
        2: '#52c41a', // 已推送 - 绿色
      }
      return colorMap[status] || '#d9d9d9' // 默认灰色
    },
  },
}
</script>

<style scoped>
.reading-approval {
  padding: 24px;
  background: #fff;
}
.filter-form {
  margin-bottom: 24px;
}
.dashboard {
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
}
.dashboard-item {
  background: #fbfbfb;
  border-radius: 4px;
  box-shadow: 0 2px 8px #f0f1f2;
  padding: 16px;
  flex: 1;
  margin-right: 16px;
}

.dashboard-item:last-child {
  margin-right: 0;
}
.progress-board {
  padding: 16px;
  /* background-color: #fff; */
  padding-top: 0px;
  border-radius: 4px;
}
.stats-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-top: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
}
.stats-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}
.stats-total {
  font-size: 14px;
  color: #666;
}
.stats-item {
  margin-bottom: 20px;
}
.stats-info {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}
.stats-label {
  font-size: 14px;
  color: #666;
  margin-right: 10px;
}
.stats-value {
  font-size: 20px;
  font-weight: bold;
  margin-right: 4px;
}
.stats-unit {
  font-size: 14px;
  color: #666;
  margin-right: 8px;
}
.stats-percent {
  font-size: 14px;
  color: #999;
}
.primary {
  color: #1890ff;
  font-weight: bold;
}
.danger {
  color: #f5222d;
  font-weight: bold;
}
.warning {
  color: #ffa39e;
  font-weight: bold;
}
.success {
  color: #52c41a;
  font-weight: bold;
}
.reading-table {
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 8px #f0f1f2;
  margin-bottom: 24px;
}
.status-unread {
  color: #f5222d;
}
.status-pending {
  color: #1890ff;
}
.status-readed {
  color: #52c41a;
}
::v-deep .ant-progress-outer {
  display: inline-block;
  width: 95%;
}

/* 防止表头换行 */
::v-deep .ant-table-thead > tr > th {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

/* 确保表格单元格内容不换行 */
::v-deep .ant-table-tbody > tr > td {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
